import sendings from './sendings'

const notificationsEvents = {
  hints: {
    balance: {
      limit: {
        balance: 'Notify when balance is {amount}',
        onLimit: 'When balance is',
        onNullBalance: 'Notify when balance is zero',
        noLimit: '<not specified>',
        notifyBy: 'notify via',
        noNotifications: '<no method selected>',
        overdraft: ' + user overdraft',
        extraRecipients: 'Notifications on the balance status of all users of the system',
        invoice: 'Attach invoice for the amount {amount}',
        empty: 'No limits are set.<br>You will not receive balance notifications.',
        permission: {
          read: 'You do not have permission to change limits.',
          write: 'You can add a limit by clicking the "Add" button below.'
        }
      }
    }
  },

  labels: {
    balance: {
      limit: {
        host: 'Host',
        port: 'Port',
        from: 'From',
        login: 'Login',
        password: 'Password',
        limit: 'Limit',

        include: {
          overdraft: 'Including overdraft',
          invoice: {
            detach: 'Detach invoice for {amount}',
            send: 'Send invoice for {amount}'
          }
        },

        notInclude: {
          overdraft: 'Not including overdraft',
          invoice: 'Do not send invoice'
        },

        invoice: {
          amount: 'Invoice amount'
        }
      }
    },

    providers: {
      health: {
        recipients: 'Provider health notifications recipients'
      }
    }
  },

  buttons: {
    balance: {
      limit: {
        invoice: {
          attach: 'Attach invoice',
          detach: 'Detach invoice'
        }
      }
    }
  }
}

export const paths = {
  billings: {
    autoAccrual: 'Auto top-up',
    billOnErrors: 'Charge SMS in case of error',
    currency: 'Currency',
    overdraft: 'Overdraft',
    processChildrenOperations: 'Process financial operations of child users as own'
  },

  integrations: {
    pyrus: {
      credentials: 'Credentials for connecting to Pyrus'
    }
  },

  referral: {
    billings: {
      processedChildOperations: 'Process referral program financial operations of child users as own'
    }
  },

  reports: {
    maxConcurrentGenerating: 'Maximum number of reports generated simultaneously'
  },

  sendings: {
    allowDuplicates: 'Allow duplicate messages',
    sendernamesCheck: 'Restrict sender names for types',
    patternsCheck: 'Mandatory moderation pattern check for types',

    duplicates: {
      hashFields: 'Fields for duplicate check',
      timeout: 'Duplicate blocking time'
    },

    phoneNumber: {
      checkMobile: 'Check mobile numbers'
    },

    rateLimit: {
      maxAmount: 'Number of messages',
      timeout: 'Time interval'
    },

    tilda: {
      sendFromForms: 'Allow sending messages from Tilda forms'
    }
  },

  smpp: {
    defaultMessageType: 'Default message type',
    enabled: 'SMPP enabled',
    ipWhitelist: 'Whitelist',
    rudeMode: 'Rude mode'
  },

  webhooks: 'Webhooks',

  notifications: {
    email: {
      recipients: 'Email notification recipients'
    },

    sms: {
      recipients: 'SMS notification recipients'
    }
  },

  websocket: {
    channels: 'Channels'
  }
}
export const descriptions = {
  billings: {
    overdraft: 'Overdraft is the amount by which you can exceed your balance. If overdraft is not specified, it is zero.',
    autoAccrual: 'Auto top-up allows you to automatically top up your balance when the threshold value is reached.',
    processChildrenOperations: 'If enabled, financial operations of child users will be processed as your own.',
    billOnErrors: 'If enabled, a fee will be charged in case of SMS sending error.',
    currency: 'The currency in which financial operations will be performed.'
  },

  integrations: {
    pyrus: {
      credentials: 'Username and security key can be obtained in the Pyrus settings.'
    }
  },

  notifications: {
    enabled: 'Enables or disables all notifications.',

    email: {
      recipients: 'Specify the email addresses to which notifications will be sent. Addresses must be separated by commas or line breaks.'
    },

    sms: {
      recipients: 'Specify the phone numbers to which notifications will be sent. Numbers must be separated by commas or line breaks. Number format: +79991234567.'
    }
  },

  referral: {
    billings: {
      processedChildOperations: 'The reward you get for operations of child users. You can set up to two rows: one for accruals and one for subtractions, the same source cannot be repeated. For each row specify the percent of the operation amount and the minimum and maximum reward amount.'
    }
  },

  reports: {
    maxConcurrentGenerating: 'Must be greater than or equal to 0 and less than 10.'
  },

  sendings: {
    allowDuplicates: 'Allows sending duplicate messages. If disabled, duplicates will be blocked.',
    sendernamesCheck: 'Restricts sender names by type. If enabled, sender names will be checked against templates.',
    patternsCheck: 'Mandatory moderation template check by type. If enabled, messages will be checked against moderation templates.',

    duplicates: {
      hashFields: 'Fields by which duplicates will be checked. If fields are not specified, all message fields will be checked.',
      timeout: 'Duplicate blocking time in seconds. If time is not specified, duplicates will be blocked for 24 hours.'
    },

    phoneNumber: {
      checkMobile: 'Validates the number type: only mobile numbers are considered valid. Landline and other non‑mobile types are treated as invalid.'
    },

    rateLimit: {
      maxAmount: 'The maximum number of messages that can be sent during the specified time interval.',
      timeout: 'Time interval in seconds during which the message limit will apply.'
    },

    tilda: {
      sendFromForms: 'Allows sending messages from Tilda forms. If disabled, messages from Tilda forms will be blocked.'
    }
  },

  smpp: {
    defaultMessageType: 'The message type that will be used by default for SMPP.',
    enabled: 'Enables or disables SMPP. If disabled, SMPP will be unavailable.',
    ipWhitelist: 'Only valid IP addresses, separated by "comma" or "line break".',
    rudeMode: 'SMPP rude mode.'
  },

  websocket: {
    channels: 'Channels to which notifications will be sent.'
  }
}

export default {
  title: 'User settings',

  titles: {
    sendings: 'Sendings',
    billings: 'Billings',
    referral: 'Referral',
    websocket: 'Websocket',
    smpp: 'SMPP',
    webhooks: 'Webhooks',
    notifications: 'Notifications',
    integrations: 'Integrations',
    reports: 'Reports'
  },

  subtitles: {
    notifications: {
      events: {
        me: 'Notifications for self',
        child: 'Notifications for child users'
      }
    },

    webhooks: {
      onStatusChange: 'On status change',
      onIncomingMessage: 'Incoming',
      request: 'Request parameters',
      successOn: 'Successful request conditions',
      statuses: 'Statuses'
    }
  },

  dialogs: {
    titles: {
      webhooks: {
        onStatusChange: 'On status change',
        onIncomingMessage: 'Incoming'
      }
    }
  },

  paths,
  descriptions,

  labels: {
    notSet: 'Not set',
    notChosen: 'Not chosen',

    billings: {
      overdraft: 'Overdraft',
      processChildrenOperations: 'Process child users financial operations as your own',
      billOnErrors: 'Charge SMS on errors',
      currency: 'Currency',

      autoAccrual: {
        limit: 'Threshold',
        requiredBalance: 'Required balance'
      }
    },

    integrations: {
      pyrus: {
        credentials: {
          login: 'Username',
          security_key: 'Security key'
        }
      },

      yclients: {
        applicationCredentials: {
          id: 'Application ID',
          token: 'Application token'
        }
      }
    },

    notifications: {
      extraRecipients: 'Notification recipients',
      type: 'Notification method',
      events: notificationsEvents.labels,
      childrenUsersEvents: notificationsEvents.labels
    },

    referral: {
      billings: {
        processedChildOperations: 'Referral program'
      }
    },

    reports: {
      maxConcurrentGenerating: 'Maximum number of reports generated concurrently'
    },

    sendings: {
      allowDuplicates: 'Allow message duplicates',

      rateLimit: {
        maxAmount: 'Message count',
        timeout: 'Time interval'
      },

      duplicates: {
        hashFields: 'Fields for duplicate check',
        timeout: 'Duplicate blocking time'
      },

      tilda: {
        sendFromForms: 'Allow sending messages from Tilda forms'
      },

      phoneNumber: {
        checkMobile: 'Validate mobile numbers'
      }
    },

    smpp: {
      enabled: 'SMPP enabled',
      rudeMode: 'SMPP rude mode',
      defaultMessageType: 'Default SMPP message type',
      ipWhitelist: 'Whitelist',
      ipAddresses: 'IP addresses',
      confirm: 'Save confirmation'
    },

    webhooks: {
      url: 'URL',
      method: 'Method',
      headers: 'Headers',
      body: 'Body',
      maxConnections: 'Connections',

      successOn: {
        status: 'Status',
        body: 'Body'
      },

      extras: {
        statuses: sendings.statuses
      }
    },

    websocket: {
      channels: 'Channels'
    }
  },

  hints: {
    billings: {
      autoAccrual: {
        limit: 'Threshold',
        requiredBalance: 'Required balance'
      }
    },

    integrations: {
      pyrus: {
        credentials: 'The username and security key are available in the Pyrus settings.'
      }
    },

    notifications: {
      events: notificationsEvents.hints,
      childrenUsersEvents: notificationsEvents.hints
    },

    referral: {
      billings: {
        processedChildOperations: {
          source: 'Source',
          percent: 'Percent',
          limitMin: 'Minimum',
          limitMax: 'Maximum'
        }
      }
    },

    reports: {
      maxConcurrentGenerating: 'Must be greater than or equal to 0 and less than 10.'
    },

    sendings: {},

    smpp: {
      ipAddresses: 'Only valid IP addresses, separator "comma", "newline".'
    },

    webhooks: {
      maxConnections: 'Maximum number. Default is 10.',

      successOn: {
        status: 'Regular expressions are allowed. Default is 200.',
        body: 'Regular expressions are allowed.'
      }
    },

    websocket: {}
  },

  buttons: {
    notifications: {
      events: notificationsEvents.buttons,
      childrenUsersEvents: notificationsEvents.buttons
    }
  },

  warnings: {
    smpp: {
      ipAddresses: 'Some of the entered IP addresses failed the validity check.<br>If you need to keep these addresses, make sure they are correct, then re-enter them in the "IP addresses" field and click "Save"<br>If the addresses are still invalid, this dialog will remain open, and the list below will update with the new invalid addresses.'
    }
  },

  items: {
    websocket: {
      channels: {
        dbUpdates: 'DB update',
        everything: 'Everything',
        health: 'Health',
        sendingStatusUpdates: 'Sending status updates',
        providersStatesUpdates: 'Providers states updates'
      }
    }
  },

  snackbars: {
    updated: 'Setting successfully updated.'
  }
}
